// Home services carousel scaffold (rotating preview of services).

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import Card from "../../ui/Card";
import Container from "../../layout/Container";
import { useLanguage } from "../../../i18n/LanguageContext";
import Button from "../../ui/Button";

export function ServicesCarousel() {
  const { t, lang } = useLanguage();
  const services = t.services.cards.map((s) => ({ title: s.title, desc: s.desc }));
  const isRtl = lang === "ar";

  return (
    <Container>
      <section className="services-section">
        <h2>{t.home.servicesCarousel.title}</h2>

        <div className="services-wrapper">
          {/* Swiper carousel to display service cards, with navigation and pagination enabled */}
          <Swiper
            key={lang}
            modules={[Navigation, Pagination]}
            slidesPerView={1}
            spaceBetween={20}
            loop={true}
            pagination={{ clickable: true }}
            centeredSlides={true}
            navigation={{
              nextEl: isRtl ? ".swiper-button-prev" : ".swiper-button-next",
              prevEl: isRtl ? ".swiper-button-next" : ".swiper-button-prev",
            }}
            breakpoints={{
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
            }}
          >
            {services.map((service, i) => (
              <SwiperSlide key={i}>
                <Card
                  className="service-card"
                  title={service.title}
                  description={service.desc}
                />
              </SwiperSlide>
            ))}
          </Swiper>

          {/* Custom navigation Arrowa for the Swiper */}
          <button className="swiper-button-prev" aria-label="previous">
            {/*SVG path */}
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="#75162d"
              strokeWidth="3"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9 5l7 7-7 7"
              />
            </svg>
          </button>
          <button className="swiper-button-next" aria-label="next">
            {/*SVG path */}
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="#75162d"
              strokeWidth="3"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M15 19l-7-7 7-7"
              />
            </svg>
          </button>
        </div>
        {/*Link to the full services page */}
        <div className="more-services">
          <Button to="/services" variant="primary" className="btn">
            {t.home.servicesCarousel.more}
          </Button>
        </div>
      </section>
    </Container>
  );
}
